import DescriptionIcon from '@material-ui/icons/Description';
import VideoIcon from '@material-ui/icons/MovieFilter';
import AudioIcon from '@material-ui/icons/MusicNote';
import PhotoIcon from '@material-ui/icons/Photo';
import React from 'react';

/* */
export default ({ mimetype }) => {
  if (mimetype.match(/image\/*/i)) return <PhotoIcon />;
  if (mimetype.match(/video\/*/i)) return <VideoIcon />;
  if (mimetype.match(/audio\/*/i)) return <AudioIcon />;

  return <DescriptionIcon />;
};
